import { api } from '@/scripts/api';

export const SharedAssetService = {
    /**
     * Get shared assets based on the query options.
     *
     * @param {import('odata-query').QueryOptions<any>} queryConfig
     */
    async getSharedAssets(queryConfig= {}) {
        const query = api.buildODataQuery(queryConfig);
        const endpoint = `/service/SharedAssets${query}`;
        return api.get(endpoint);
    },
};